export default "__VITE_ASSET__a8b73b57__"